import { ChangeDetectionStrategy, Component } from '@angular/core';
import { OverflowShadowDirective } from '@app/directives/overflow-shadow.directive';

@Component({
  selector: 'app-scroll',
  templateUrl: './scroll.component.html',
  styleUrl: './scroll.component.scss',
  imports: [],
  hostDirectives: [OverflowShadowDirective],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ScrollComponent {}
